import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllAgitemdetails = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitemdetail/`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneAgitemdetail = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitemdetail/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchTaxAndPricelistOfItems = (data = {}) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/agitemdetail/fetch-tax-and-pricelist`,
      data,
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchCompleteAgitemdetails = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitemdetail/allitemdetails`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteAgitemdetail = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/agitemdetail/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateAgitemdetail = (data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/agitemdetail/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchDetailsWithSize = (itemCodeWithoutSize) => {
  return axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/agitemdetail/details-with-size/${itemCodeWithoutSize}`,
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const checkItemDetailUsage = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitemdetail/check-usage/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const editItemDetail = ({ itemId, ...data }) => {
  return axios
    .put(
      `${process.env.REACT_APP_BASE_URL}/agitemdetail/edit/${itemId}`,
      data,
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
